import { v4 as uuid } from 'uuid';

export const generateKey = (prefix?: string) => {
    return [prefix, uuid()].filter(Boolean).join('-');
};
